import EnrolmentsAdapter from './base';

export default class Log extends EnrolmentsAdapter {
  modelNamePlural = 'logs';
}
